var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphEmotionalSupport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 8)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFD74B",
    cx: 13,
    cy: 18.678,
    r: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.677 37.491-4.705-.661a6 6 0 0 0-5.828 2.614l-11.7 17.56a2.5 2.5 0 0 0 1.732 3.861l4.705.662a6 6 0 0 0 5.828-2.615l11.7-17.559a2.5 2.5 0 0 0-1.732-3.862z",
    fill: "#BDD9FF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(5 11.47 262.698)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#BDD9FF",
    cx: 20.994,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#5AA0FF",
    transform: "rotate(20 11.665 29.53)",
    x: 4.165,
    y: 16.03,
    width: 15,
    height: 27,
    rx: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.905 36.178h5.251a6 6 0 0 1 5.406 3.397l9.639 20.019a2.5 2.5 0 0 1-2.253 3.584h-5.251a6 6 0 0 1-5.406-3.397l-9.638-20.018a2.5 2.5 0 0 1 2.252-3.585z",
    fill: "#5AA0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#BDD9FF",
    transform: "rotate(55 23.462 28.03)",
    x: 18.462,
    y: 14.029,
    width: 10,
    height: 28,
    rx: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphEmotionalSupport);
export default __webpack_public_path__ + "static/media/icons_graph_emotional_support.72c39daccdb337cdb2cb6fe6eb87ad59.svg";
export { ForwardRef as ReactComponent };